module.exports = __webpack_public_path__ + "static/media/12_l_dom_0_3.52.ccd666f3.png";